import { getApi } from "./api_instance";

export const getAllRegistries = async () => {
  try {
    return await getApi({
      apiUrl: "/projects/api/registry/getAllRegistires",
    });
  } catch (error) {
    throw error;
  }
};
